import { observer } from 'mobx-react-lite'
import { useId } from 'react'
import { type EditProfileViewModel } from '@/features/account/PersonalInfoView/EditProfileDialog/EditProfileViewModel'
import { FormContainer } from '@/components/FormContainer'
import { TextFieldContainer } from '@/components/inputs/TextFieldContainer'
import { EditProfileDialog, EditProfileDialogContactSupportHint } from './index'

export interface EditProfileDialogContainerProps {
  vm: EditProfileViewModel
}

export const EditProfileDialogContainer = observer(
  function EditProfileDialogContainer({ vm }: EditProfileDialogContainerProps) {
    const formId = useId()
    return (
      <EditProfileDialog
        isOpen={vm.modal.showing}
        isDismissable={!vm.save.pending}
        isPending={vm.save.pending}
        formId={formId}
        onClose={vm.modal.close}
      >
        <FormContainer
          compact
          id={formId}
          onSubmit={vm.save}
          disabled={vm.save.pending}
        >
          <TextFieldContainer model={vm} field="givenName" label="First name" />
          <TextFieldContainer model={vm} field="familyName" label="Last name" />
          <TextFieldContainer
            model={vm}
            type="email"
            field="email"
            label="Email address"
            disabled
            hint={<EditProfileDialogContactSupportHint />}
          />
          <TextFieldContainer model={vm} field="phone" label="Phone number" />
        </FormContainer>
      </EditProfileDialog>
    )
  },
)
